__webpack_require__.p = "/boost-rpg-tools/";